// src/routes/BlogPage.js
import React from "react";
import Navbar from "../components/Navbar";
import PageHero from "../components/PageHero";
import Blog from "../components/Blog";
import Footer from "../components/Footer";

const BlogPage = () => (
  <div>
    <Navbar />
    <PageHero label="Writing" heading="Blog." sub="Thoughts on tech, projects, and life along the way." />
    <Blog title="All Posts" />
    <Footer />
  </div>
);

export default BlogPage;
